import { Reveal } from "@/components/common/Reveal";
import { cn } from "@/lib/utils";

// Shared hero band for inner pages. tone: "light" | "navy".
export const PageHeader = ({ overline, title, subtitle, tone = "light" }) => {
  const navy = tone === "navy";
  return (
    <section className={cn("pt-[72px]", navy ? "bg-navy" : "border-b border-border")} data-testid="page-header">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
        <Reveal>
          <p className={cn("overline", navy && "text-blue-400")}>{overline}</p>
          <h1
            className={cn(
              "mt-5 max-w-3xl font-heading text-4xl font-extrabold leading-[1.02] tracking-tighter md:text-5xl lg:text-6xl",
              navy ? "text-white" : "text-slate-900"
            )}
          >
            {title}
          </h1>
          {subtitle && (
            <p className={cn("mt-6 max-w-2xl text-lg leading-relaxed", navy ? "text-slate-300" : "text-slate-600")}>
              {subtitle}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
};
